import { render, staticRenderFns } from "./RequestRoadsInfo.vue?vue&type=template&id=b71708e6&"
import script from "./RequestRoadsInfo.vue?vue&type=script&lang=js&"
export * from "./RequestRoadsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QInput,QItemSection,QSelect,QBtn,QTooltip,QCheckbox,QItemLabel,QTable,QTr,QTh} from 'quasar'
component.options.components = Object.assign({QItem,QInput,QItemSection,QSelect,QBtn,QTooltip,QCheckbox,QItemLabel,QTable,QTr,QTh}, component.options.components || {})
